export enum PaymentMethodEnum {
    Cash = 'cash',
    Card = 'card',
    Online = 'online',
    Mobile = 'mobile',

    // A synthetic tender: the sales overview splits redeemed gift vouchers
    // into their own bucket, and a receipt may be part-paid by one.
    Voucher = 'voucher',
}
